<template>
    <TransitionRoot appear :show="open" as="template" @keyup.esc="closeModal">
        <Dialog as="div" class="relative z-50">
            <TransitionChild as="template" appear enter="duration-300 ease-in-out" enter-from="opacity-0 bg-slate-800"
                enter-to="opacity-100" leave="duration-200 ease-in-out" leave-from="opacity-100" leave-to="opacity-0">
                <div
                    class="fixed inset-0 bg-gray-800 bg-opacity-50 dark:bg-gray-600 dark:bg-opacity-40 backdrop-blur-[1px]" />
            </TransitionChild>
            <div class="fixed inset-0 flex flex-col overflow-y-auto mx-2">
                <div class="relative">
                    <TransitionChild as="template" appear enter="transition transform duration-300 ease-in-out"
                        enter-from="opacity-0 translate-y-10" enter-to="opacity-100 translate-y-0"
                        leave="transition transform duration-200 ease-in-out" leave-from="opacity-100 translate-y-0"
                        leave-to="opacity-0 translate-y-10">
                        <DialogPanel class="relative">
                            <div
                                class="absolute lg:left-2 top-12 w-full lg:max-w-fit bg-stone-700 dark:bg-slate-800 px-4 py-8 max-h-360px rounded-md shadow-xl">
                                <div
                                    class="absolute left-0 right-0 mx-auto -top-2 lg:right-auto lg:left-10 w-0 h-0 border-l-8 border-r-8 border-l-transparent border-r-transparent border-b-8 border-b-stone-700 dark:border-b-slate-800">
                                </div>
                                <div
                                    class="absolute right-4 top-2 flex justify-end text-slate-300 hover:text-red-300 transition-colors duration-75 ease-out cursor-pointer">
                                    <font-awesome-icon icon="times" @click="closeModal" />
                                </div>
                                <div class="flex flex-col space-y-2">
                                    <template v-for="(module, index) in modulos" :key="index">
                                        <Link :href="module.value"
                                            class="bg-stone-500 dark:bg-slate-700 hover:text-stone-700 hover:bg-stone-400 dark:hover:bg-slate-600 transition-colors ease-out duration-75 text-stone-100 dark:text-slate-300 text-left rounded-md px-4 py-2 shadow-lg font-normal capitalize cursor-pointer"
                                            v-if="module.type == 'button'" @click="emit('setModule', module.menu)">
                                            {{ module.label }}
                                    </Link>
                                        <a target="_blank" :href="module.value" v-if="module.type == 'link'"
                                            class="bg-stone-500 dark:bg-slate-700 hover:text-stone-700 hover:bg-stone-400 dark:hover:bg-slate-600 transition-colors ease-out duration-75 text-stone-100 dark:text-slate-300 text-left rounded-md px-4 py-2 shadow-lg font-normal capitalize cursor-pointer">
                                            {{ module.label }}
                                        </a>
                                    </template>
                                </div>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script setup>
import { reactive, ref } from "vue";
import { modulos } from "@/Pages/Sistema/Workbench/constants";
import {
    TransitionRoot,
    TransitionChild,
    Dialog,
    DialogPanel,
    DialogTitle,
} from "@headlessui/vue";
import { Link } from "@inertiajs/vue3";


const props = defineProps({
    twclass: [String, Object],
    open: {
        type: Boolean,
        default: false,
    },
});





const emit = defineEmits(["open", "setModule"]);

function closeModal() {
    emit("open");
}

defineExpose({
    modulos,
});

</script>

<style></style>
